import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Svg from 'rp-react-svg-icon';
import axios from 'axios';
import classNames from 'classnames';
import { capitalize, sortBy } from 'lodash';
import RunnerSelect from './components/RunnerSelect';
import StudFee from './components/StudFee';
import NameContainer from './components/NameContainer';
import * as horseUtils from '../../utils/horse';
import Image from '../../shared/Image';
import HorseTracker from '../../shared/horseTracker';
import Standing from '../details/components/Standing';

class NameRow extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            fetched: false,
            runners: [],
        };
    }

    componentDidMount() {
        const { hash } = this.props.params;

        if (!hash) {
            return;
        }

        const raceId = hash.split('=').pop();
        this.fetchData(raceId);
    }

    fetchData(raceId) {
        axios.get(`horse/data/cardrunners/${raceId}.json`)
            .then(({ data: { runners } }) => {
                this.setState({
                    runners: sortBy(runners, 'startNumber'),
                    fetched: true,
                });
            })
            .catch(error => console.warn(error));
    }

    render() {
        const { runners, fetched } = this.state;
        const {
            imagesHost,
            profile,
            params,
            isMobile,
            isWeatherbysSire,
        } = this.props;
        const {
            horseName,
            horseUid,
            horseCountryOriginCode,
            silkImagePath,
            studFee,
        } = profile;

        const horseType = horseUtils.getHorseType(profile);
        const hasProgeny = horseUtils.hasProgeny(profile);

        const selectedHorseIndex = runners.findIndex(r => r.horseUid === horseUid);

        const nameRowClass = classNames(
            'hp-nameRow',
            hasProgeny && 'hp-nameRow_pedigree',
            params.hash && 'hp-nameRow_inSelect'
        );

        const horseTypeClassName = classNames(
            isWeatherbysSire && 'hp-nameRow__progenyIcon--hidden'
        );

        return (
            <div>
                {hasProgeny &&
                <span className="hp-nameRow__progenyIcon">
                    <Svg
                        className={horseTypeClassName}
                        iconName={horseType}
                        size={capitalize(horseType)}
                    />
                    </span>
                }
                <div className={nameRowClass}>
                    <div className="hp-nameRow__horseDetails">
                        {silkImagePath &&
                        <Image
                            src={`${imagesHost}/png_silks/${silkImagePath}.png`}
                            imgHost={imagesHost}
                            imgClass="hp-nameRow__silk"
                            alt="Horse Profile - Jockey Colours"
                        />
                        }
                        {fetched && selectedHorseIndex > -1 ? (
                            <RunnerSelect
                                runners={runners}
                                selectedHorseIndex={selectedHorseIndex}
                            />
                        ) : (
                            <NameContainer
                                horseName={horseName}
                                countryCode={horseCountryOriginCode}
                            />
                        )}

                        {
                            isMobile && profile.weatherbysUid ?
                                <HorseTracker profile={profile} /> : ''
                        }
                    </div>
                    <div className="hp-nameRow__rightContainer">
                        {
                            profile && profile.weatherbysUid ?
                                <Standing key="Standing" {...profile} />
                                : ''
                        }
                        <StudFee isWeatherbys={profile.weatherbysUid} data={studFee} />
                        {
                            isMobile && profile.weatherbysUid ?
                                '' : <HorseTracker profile={profile} />
                        }
                    </div>
                </div>
            </div>
        );
    }
}

NameRow.propTypes = {
    profile: PropTypes.shape({
        horseName: PropTypes.string.isRequired,
        horseUid: PropTypes.number.isRequired,
        horseCountryOriginCode: PropTypes.string.isRequired,
        silkImagePath: PropTypes.string,
        sireStatus: PropTypes.bool.isRequired,
        studFee: PropTypes.arrayOf(PropTypes.shape({
            nominationFee: PropTypes.number,
            studFeeCondition: PropTypes.string,
            curCode: PropTypes.string,
            nominationYear: PropTypes.number,
        })),
    }).isRequired,
    params: PropTypes.shape({
        type: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        tab: PropTypes.string,
        hash: PropTypes.string,
    }).isRequired,
    imagesHost: PropTypes.string.isRequired,
    isMobile: PropTypes.bool,
    isWeatherbysSire: PropTypes.bool,
};

export default NameRow;



// WEBPACK FOOTER //
// ./src/js/horse/nameRow/NameRow.jsx